<template>
  <!--  form-section повешан, потому что companies-section используется еще в профиле, вне диалога -->
  <section class="form-section grid-block">
    <header> Склады
      <VLink
        material="add"
        @click="StoresService.createStore(localPartner, onStoresChanged)"
      >
        Добавить склад
      </VLink>
    </header>

    <div class="content">
      <VDataGridV2
        :context-menu="StoresService.contextMenu"
        :loader="dataLoader"
				layout="fill"
        @row:dblclick="row => StoresService.editStore(
					row,
					onStoresChanged,
				)"
      >
        <VDataGridColumnV2
          id="name"
					conent-class="ellipsis"
					width="95%"
          label="Адрес"
        >
          <template #default="{ row }">
            <div
              :title="row.address.stringRepresentation"
            >
              {{ row.address.stringRepresentation || '--' }}

							<VBadge
								v-if="row.isDraft"
								class="draft"
							>
								Черновик
							</VBadge>
            </div>
            <div
              class="description"
              :title="row.workingTime"
            >
              {{ row.workingTime }}
            </div>
            <div
              v-if="row.notes"
              class="description"
              :title="row.notes"
            >
              {{ row.notes }}
            </div>
          </template>
        </VDataGridColumnV2>
      </VDataGridV2>
    </div>
  </section>
</template>

<script>

import Partner                  from '@/domains/Partners/Partner.ts';
import StoresService            from '@/domains/Stores/StoresService.ts';

export default defineComponent({
	name: 'StoresSection',

	props: {
		localPartner: {
			type:    Partner,
			default: null,
		},
	},

  data() {
    return {
      StoresService,
      dataLoader: this.$core.loader.dataGrid(
        () => StoresService.getListPaginated({ partnerId: this.localPartner.id })
      )
    }
  },

  methods: {
    onStoresChanged() {
      this.dataLoader.refresh();
      this.$emit('stores:updated');
    },
  }
})
</script>
